var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6884_346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6884_346)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 17.3333,
    height: 17.3333,
    rx: 8.66667,
    fill: "#7A999E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3332 45.5751C35.4876 48.4842 32.9159 50.666 24.9998 50.666C17.0838 50.666 14.8616 48.8478 10.6665 45.5751C10.6665 39.9518 17.0838 30.666 24.9998 30.666C32.9159 30.666 39.3332 39.9518 39.3332 45.5751Z",
    fill: "#7A999E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDark);
export default __webpack_public_path__ + "static/media/avatarDark.e7d50a54e378e66dd49099e3c16bb94a.svg";
export { ForwardRef as ReactComponent };